<form class="needs-validation" novalidate>
  <div class="col-md-12">
    <div class="border rounded-2 p-4">

      <h3 class="text-center">My Kaizens</h3>

      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search Kaizen"
          #searchCriteria
          (keydown.enter)="OnSearch(searchCriteria.value)"
        >

        <button
          class="btn btn-outline-info fa fa-search"
          type="button"
          (click)="OnSearch(searchCriteria.value)"
        >
          Search
        </button>
      </div>

      <br>
<div class="boldtext">Total {{totalItems}} Kaizens</div>
     <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1">

        <ng-container matColumnDef="kaizenNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>KZ NUM#</th>
          <td mat-cell *matCellDef="let kaizen">
            K{{kaizen.kaizenNumber}}
          </td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>NAMC</th>
          <td mat-cell *matCellDef="let kaizen">
            {{kaizen.company}}
          </td>
        </ng-container>

        <ng-container matColumnDef="line">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Line</th>
          <td mat-cell *matCellDef="let kaizen">
            {{kaizen.line}}
          </td>
        </ng-container>

        <ng-container matColumnDef="shop">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Shop</th>
          <td mat-cell *matCellDef="let kaizen">
            {{shopSizer(kaizen.shop.toString())}}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let kaizen">
            {{kaizen.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="account">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
          <td mat-cell *matCellDef="let kaizen">
            {{kaizen.account}}
          </td>
        </ng-container>

        <ng-container matColumnDef="fySavings">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Est Yearly Savings</th>
          <td mat-cell *matCellDef="let kaizen">
            {{kaizen.fySavings | currency:'USD':'symbol':'1.0'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="updatedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated On</th>
          <td mat-cell *matCellDef="let kaizen">
            {{kaizen.updatedOn | date:'mediumDate'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let kaizen">
            {{kaizen.state}}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
          <td mat-cell *matCellDef="let kaizen">

            @if ((kaizen.state.toString()!='Submitted' && kaizen.state.toString()!='Complete'  && kaizen.state.toString()!='In progress')) {
                    <a routerLink="/addEditKaizen/{{kaizen.kaizenId}}"><mat-icon>edit</mat-icon></a>
                  } 
            @else {
                    <mat-icon style="color: lightgray;" >edit</mat-icon>
                  }            
            &nbsp;&nbsp;

            @if ((kaizen.state.toString()=='Draft'|| kaizen.state.toString() =='Submitted' || kaizen.state.toString()=='Pending Revision')) {
                    <a class="pointer" (click)="DeleteKaizen(kaizen.kaizenId)"> <mat-icon>delete_outline</mat-icon></a>
                  } 
            @else {
                    <mat-icon style="color: lightgray;" >delete_outline</mat-icon>
                  }
            &nbsp;&nbsp;

            @if ((kaizen.state.toString()=='Cost Confirmed' || kaizen.state.toString() =='In progress'|| kaizen.state.toString() =='Complete')) {
              <a routerLink="/actuals/{{kaizen.kaizenId}}"> <mat-icon>list</mat-icon></a>
            } 
            @else {
              <mat-icon style="color: lightgray;" >list</mat-icon>
            }

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      </table>

      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageNumber - 1"
        [pageSizeOptions]="[25,50,100]"
        showFirstLastButtons
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  </div>
</form>

  <!-- <form [formGroup]="firstFormGroup">
    <div class="form-group row">
      <span class="col-sm-8"></span>
      <label for="showHiddenKaizens" class="col-sm-2 col-form-label">Show Hidden Kaizens</label>
      <label class="switch">
        <input type="checkbox" formControlName="showHiddenKaizens" id="showHiddenKaizens"
          (change)="showHiddenKaizensChange($event)">
        <span class="slider round"></span>
      </label>
    </div>
  </form> -->